import { gql } from '@apollo/client';
import { projectCard } from './helperQuery.wp';

export const loadCardsQuery = gql`
  query GetCardPosts(
    $postType: String!
    $numPosts: Int!
    $paged: Int
    $ids: [Int]
    $primaryTaxonomy: String
    $secondaryTaxonomy: String
    $taxonomies: [CardPostsTaxInput]
    $taxRelation: String
    $orderby: String
  ) {
    cardPosts(
      postType: $postType
      numPosts: $numPosts
      paged: $paged
      ids: $ids
      primaryTaxonomy: $primaryTaxonomy
      secondaryTaxonomy: $secondaryTaxonomy
      taxonomies: $taxonomies
      taxRelation: $taxRelation
      orderby: $orderby
    ) {
      posts {
        ${projectCard}
      }
      pagination {
        current
        total
        prev {
          link
          title
        }
        next {
          link
          title
        }
        pages {
          link
          title
          current
        }
      }
    }
  }
`;
